import { render } from "./JudgeBadge.vue?vue&type=template&id=4acb06c9&ts=true"
import script from "./JudgeBadge.vue?vue&type=script&lang=ts"
export * from "./JudgeBadge.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__